import type { FormatMonthLabelParams } from '../types';

const MONTH_FORMATTER = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
});

const formatMonthLabel = ({ month }: FormatMonthLabelParams): string => {
    const [year, monthNumber] = month.split('-').map(Number);
    return MONTH_FORMATTER.format(new Date(Date.UTC(year, monthNumber - 1, 1)));
};

export default formatMonthLabel;
